// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../../types/schema';

import { CharitableTrustDesignerIllustrationData_NoPlanProjectionYearlyFragment } from './CharitableTrustDesignerIllustrationData.generated';
import { gql } from '@apollo/client';
import { CharitableTrustDesignerIllustrationData_NoPlanProjectionYearlyFragmentDoc } from './CharitableTrustDesignerIllustrationData.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CharitableTrustDesignerDistributionTableData_CrtProposalYearlyProjectionFragment = { __typename?: 'CRTProposalYearlyProjection', year: number, beginningOfYear: CurrencyUSD, growth: CurrencyUSD, payout: CurrencyUSD, remainderValue: CurrencyUSD };

export type CharitableTrustDesignerDistributionTableData_CltProposalYearlProjectionFragment = { __typename?: 'CLTProposalYearlyProjection', year: number, beginningOfYear: CurrencyUSD, growth: CurrencyUSD, payout: CurrencyUSD, remainderValue: CurrencyUSD };

export type CharitableTrustDesignerDistributionTableDataQueryVariables = Types.Exact<{
  crtProjectionInput: Types.CrtProposalProjectionInput;
  cltProjectionInput: Types.CltProposalProjectionInput;
  noPlanProjectionInput: Types.NoPlanProjectionInput;
  isCRT: Types.Scalars['Boolean']['input'];
  isOpen: Types.Scalars['Boolean']['input'];
}>;


export type CharitableTrustDesignerDistributionTableDataQuery = { __typename?: 'Query', crtDistributionTableProjection?: { __typename?: 'CRTProposalProjection', yearly?: Array<(
      { __typename?: 'CRTProposalYearlyProjection' }
      & CharitableTrustDesignerDistributionTableData_CrtProposalYearlyProjectionFragment
    )> }, cltDistributionTableProjection?: { __typename?: 'CLTProposalProjection', yearly?: Array<(
      { __typename?: 'CLTProposalYearlyProjection' }
      & CharitableTrustDesignerDistributionTableData_CltProposalYearlProjectionFragment
    )> }, noPlanDistributionTableProjection: { __typename?: 'NoPlanProjection', yearly?: Array<(
      { __typename?: 'NoPlanProjectionYearly' }
      & CharitableTrustDesignerIllustrationData_NoPlanProjectionYearlyFragment
    )> } };

export const Operations = {
  Query: {
    CharitableTrustDesignerDistributionTableData: 'CharitableTrustDesignerDistributionTableData' as const
  },
  Fragment: {
    CharitableTrustDesignerDistributionTableData_CRTProposalYearlyProjection: 'CharitableTrustDesignerDistributionTableData_CRTProposalYearlyProjection' as const,
    CharitableTrustDesignerDistributionTableData_CLTProposalYearlProjection: 'CharitableTrustDesignerDistributionTableData_CLTProposalYearlProjection' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const CharitableTrustDesignerDistributionTableData_CrtProposalYearlyProjectionFragmentDoc = gql`
    fragment CharitableTrustDesignerDistributionTableData_CRTProposalYearlyProjection on CRTProposalYearlyProjection {
  year
  beginningOfYear
  growth
  payout
  remainderValue
}
    `;
export const CharitableTrustDesignerDistributionTableData_CltProposalYearlProjectionFragmentDoc = gql`
    fragment CharitableTrustDesignerDistributionTableData_CLTProposalYearlProjection on CLTProposalYearlyProjection {
  year
  beginningOfYear
  growth
  payout
  remainderValue
}
    `;
export const CharitableTrustDesignerDistributionTableDataDocument = gql`
    query CharitableTrustDesignerDistributionTableData($crtProjectionInput: CRTProposalProjectionInput!, $cltProjectionInput: CLTProposalProjectionInput!, $noPlanProjectionInput: NoPlanProjectionInput!, $isCRT: Boolean!, $isOpen: Boolean!) {
  crtDistributionTableProjection: crtProposalProjection(
    input: $crtProjectionInput
  ) @include(if: $isCRT) {
    yearly @include(if: $isOpen) {
      ...CharitableTrustDesignerDistributionTableData_CRTProposalYearlyProjection
    }
  }
  cltDistributionTableProjection: cltProposalProjection(
    input: $cltProjectionInput
  ) @skip(if: $isCRT) {
    yearly @include(if: $isOpen) {
      ...CharitableTrustDesignerDistributionTableData_CLTProposalYearlProjection
    }
  }
  noPlanDistributionTableProjection: noPlanProjection(
    input: $noPlanProjectionInput
  ) {
    yearly @include(if: $isOpen) {
      ...CharitableTrustDesignerIllustrationData_NoPlanProjectionYearly
    }
  }
}
    ${CharitableTrustDesignerDistributionTableData_CrtProposalYearlyProjectionFragmentDoc}
${CharitableTrustDesignerDistributionTableData_CltProposalYearlProjectionFragmentDoc}
${CharitableTrustDesignerIllustrationData_NoPlanProjectionYearlyFragmentDoc}`;

/**
 * __useCharitableTrustDesignerDistributionTableDataQuery__
 *
 * To run a query within a React component, call `useCharitableTrustDesignerDistributionTableDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useCharitableTrustDesignerDistributionTableDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCharitableTrustDesignerDistributionTableDataQuery({
 *   variables: {
 *      crtProjectionInput: // value for 'crtProjectionInput'
 *      cltProjectionInput: // value for 'cltProjectionInput'
 *      noPlanProjectionInput: // value for 'noPlanProjectionInput'
 *      isCRT: // value for 'isCRT'
 *      isOpen: // value for 'isOpen'
 *   },
 * });
 */
export function useCharitableTrustDesignerDistributionTableDataQuery(baseOptions: Apollo.QueryHookOptions<CharitableTrustDesignerDistributionTableDataQuery, CharitableTrustDesignerDistributionTableDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CharitableTrustDesignerDistributionTableDataQuery, CharitableTrustDesignerDistributionTableDataQueryVariables>(CharitableTrustDesignerDistributionTableDataDocument, withFetchPolicyContext(options));
      }
export function useCharitableTrustDesignerDistributionTableDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CharitableTrustDesignerDistributionTableDataQuery, CharitableTrustDesignerDistributionTableDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CharitableTrustDesignerDistributionTableDataQuery, CharitableTrustDesignerDistributionTableDataQueryVariables>(CharitableTrustDesignerDistributionTableDataDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useCharitableTrustDesignerDistributionTableDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CharitableTrustDesignerDistributionTableDataQuery, CharitableTrustDesignerDistributionTableDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CharitableTrustDesignerDistributionTableDataQuery, CharitableTrustDesignerDistributionTableDataQueryVariables>(CharitableTrustDesignerDistributionTableDataDocument, withFetchPolicyContext(options));
        }
export type CharitableTrustDesignerDistributionTableDataQueryHookResult = ReturnType<typeof useCharitableTrustDesignerDistributionTableDataQuery>;
export type CharitableTrustDesignerDistributionTableDataLazyQueryHookResult = ReturnType<typeof useCharitableTrustDesignerDistributionTableDataLazyQuery>;
export type CharitableTrustDesignerDistributionTableDataSuspenseQueryHookResult = ReturnType<typeof useCharitableTrustDesignerDistributionTableDataSuspenseQuery>;
export type CharitableTrustDesignerDistributionTableDataQueryResult = Apollo.QueryResult<CharitableTrustDesignerDistributionTableDataQuery, CharitableTrustDesignerDistributionTableDataQueryVariables>;